var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfPauseBars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17.984,
    height: 17.984,
    viewBox: "0 0 17.984 17.984",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7402 3H11.2415C10.8277 3 10.4922 3.33549 10.4922 3.74933V14.24C10.4922 14.6538 10.8277 14.9893 11.2415 14.9893H12.7402C13.154 14.9893 13.4895 14.6538 13.4895 14.24V3.74933C13.4895 3.33549 13.154 3 12.7402 3Z",
    stroke: "#4A5565",
    strokeWidth: 1.49867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.74409 3H5.24543C4.83158 3 4.49609 3.33549 4.49609 3.74933V14.24C4.49609 14.6538 4.83158 14.9893 5.24543 14.9893H6.74409C7.15794 14.9893 7.49343 14.6538 7.49343 14.24V3.74933C7.49343 3.33549 7.15794 3 6.74409 3Z",
    stroke: "#4A5565",
    strokeWidth: 1.49867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfPauseBars);
export default __webpack_public_path__ + "static/media/cf-pause-bars.bffae17e04042f8d1e4e00368a2b6a7e.svg";
export { ForwardRef as ReactComponent };